export interface TabsInfo {
    name: string,
    title: string,
}

export class InitHome {
    TabsList: TabsInfo[] = [];
}
